"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _Component2 = _interopRequireDefault(require("../../Component"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _stepper = _interopRequireDefault(require("../styles/stepper"));

var _createStyled = _interopRequireDefault(require("../../../utils/createStyled"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Div = _createStyled["default"].div(_templateObject());

var Stepper =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Stepper, _Component);

  function Stepper() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, Stepper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Stepper)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_isActive", function (index) {
      return index + 1 === _this.props.active;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_isPassed", function (index) {
      return index + 1 < _this.props.active;
    });
    return _this;
  }

  (0, _createClass2["default"])(Stepper, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          style = _this$props.style,
          vertical = _this$props.vertical,
          children = _react["default"].Children.toArray(this.props.children),
          styles = this.compileStyled(_stepper["default"]),
          content = [],
          divider = _react["default"].createElement(Div, {
        styles: styles.dividerWrapper
      }, _react["default"].createElement(Div, {
        styles: styles.divider
      }));

      var steps = [];

      if (children && children.length) {
        steps = children.map(function (item, i) {
          return _react["default"].cloneElement(item, {
            active: _this2._isActive(i),
            passed: _this2._isPassed(i),
            number: i + 1,
            key: i,
            style: style,
            vertical: vertical
          });
        });
        steps.forEach(function (step, i) {
          content.push(_react["default"].createElement(_react["default"].Fragment, {
            key: step.id || i
          }, step, i < steps.length - 1 ? divider : null));
        });
      }

      return _react["default"].createElement(Div, {
        styles: styles.root
      }, content);
    }
  }]);
  return Stepper;
}(_Component2["default"]);

(0, _defineProperty2["default"])(Stepper, "displayName", 'Stepper');
(0, _defineProperty2["default"])(Stepper, "defaultProps", {
  vertical: false
});
(0, _defineProperty2["default"])(Stepper, "propTypes", {
  active: _propTypes["default"].number,
  children: _propTypes["default"].any,
  vertical: _propTypes["default"].bool,
  style: _propTypes["default"].object,

  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    /**
     * @default palette.tsSmall
     */
    fontSize: _propTypes["default"].string,

    /**
     * @default palette.twSemi
     */
    fontWeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.tHint
     */
    color: _propTypes["default"].string,

    /**
     * @default nowrap
     */
    whiteSpace: _propTypes["default"].string,

    /**
     * @default palette.tAccent
     */
    activeColor: _propTypes["default"].string,

    /**
     * @default palette.tAccent
     */
    passedColor: _propTypes["default"].string,

    /**
     * @description number shape
     */
    number: _propTypes["default"].shape({
      /**
       * @default palette.gutter * 3 + 'px'
       */
      width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

      /**
       * @default palette.gutter * 3 + 'px'
       */
      height: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

      /**
       * @default 50%
       */
      borderRadius: _propTypes["default"].string,

      /**
       * @default palette.elDarkest
       */
      background: _propTypes["default"].string,

      /**
       * @default palette.tInversion
       */
      color: _propTypes["default"].string,

      /**
       * @default null
       */
      icon: _propTypes["default"].any,

      /**
       * @default palette.gutter + 'px'
       */
      marginRight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

      /**
       * @default palette.elAccent
       */
      activeBackground: _propTypes["default"].string,

      /**
       * @default palette.tInversion
       */
      activeColor: _propTypes["default"].string,

      /**
       * @default null
       */
      activeIcon: _propTypes["default"].any,

      /**
       * @default palette.elAccent
       */
      passedBackground: _propTypes["default"].string,

      /**
       * @default palette.tInversion
       */
      passedColor: _propTypes["default"].string,

      /**
       * @default Complete
       */
      passedIcon: _propTypes["default"].func
    }),

    /**
     * @description hint shape
     */
    hint: _propTypes["default"].shape({
      /**
       * @default palette.tsXSmall
       */
      fontSize: _propTypes["default"].string,

      /**
       * @default palette.tlXSmall
       */
      lineHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

      /**
       * @default palette.twNormal
       */
      fontWeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

      /**
       * @default palette.tHint
       */
      color: _propTypes["default"].string,

      /**
       * @default palette.tHint
       */
      activeColor: _propTypes["default"].string,

      /**
       * @default palette.tHint
       */
      passedColor: _propTypes["default"].string
    }),

    /**
     * @description divider shape
     */
    divider: _propTypes["default"].shape({
      /**
       * @default palette.elDivider
       */
      background: _propTypes["default"].string,

      /**
       * @default palette.gutter * 9 + 'px'
       */
      width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

      /**
       * @default palette.gutter + 'px'
       */
      padding: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

      /**
       * @default 2px
       */
      height: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
    })
  })
});
var _default = Stepper;
exports["default"] = _default;